import moment from 'moment';
import Api from './api';

const api = Api.getApi();

/** Get data from from pos-client-lib in localStorage */
const getDate = (date) => {
  const format = api.getConfigByKey('app_date_format');
  if (!date) {
    return '';
  }

  return moment(date).format(format);
};

/**
 * Convert value to money
 * @param {*} amount
 * @param {*} sign
 * @returns
 */
const toMoney = (amount, sign = '') => {
  if (!amount) {
    return '0.00';
  }
  const re = /\d(?=(\d{3})+\.)/g;

  return (
    sign +
    parseFloat(amount / 100)
      .toFixed(2)
      .replace(re, '$&,')
  );
};

/**
 * Convert value to number
 * @param {*} number
 * @returns
 */
const toNumber = (number) => {
  if (!number) return '';
  return number.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,');
};

/**
 * Create options for form select
 * @param {*} data
 * @param {*} fieldLabel
 * @param {*} fieldVal
 * @returns
 */
const getOptionsForSelect = (data, fieldLabel = '', fieldVal = '') =>
  data.map((el) => ({
    label: el[fieldLabel],
    value: el[fieldVal],
  }));

/** Build key for item in table */
const buildKey = (alias = 'def', val) => `${alias}-${val}`;

/**
 * Change position for element in array
 * @param {*} arr
 * @param {*} fromIndex
 * @param {*} toIndex
 * @returns
 */
const arrayMove = (arr, fromIndex, toIndex) => {
  const element = arr[fromIndex];
  arr.splice(fromIndex, 1);
  arr.splice(toIndex, 0, element);
  return arr;
};

/** Remove product identifier from pos-client-lib in localStorage */
const getIdentifierTypes = () => api.getConfigByKey('product_sku_identifier_types') || [];

/** Get value from localStorage */
const getLocalStorageValue = (key) => localStorage.getItem(key);

/** Remove value from localStorage */
const removeLocalStorageValue = (key) => localStorage.removeItem(key);

/** Create state for pos-client lib */
const createState = () => `pos-admin-frontend-${new Date() * 1}`;

/**
 * Get uri string
 * @param {*} url
 * @returns
 */
const getRedirectUri = (url) => {
  const host = window.location.origin;
  return encodeURIComponent(`${host}/${url}`);
};

/**
 * Create value for fields to submit form
 * @param {*} data
 * @param {*} fields
 * @returns
 */
const createDataFromFields = (data = {}, fields = []) => {
  const newData = {};
  fields.forEach((el) => {
    newData[el] = data[el];
  });
  return newData;
};

/**
 * Parse query url to string
 * @param {*} query
 * @returns
 */
function parseQueryString(query) {
  if (!query) return {};
  const vars = query.substring(1).split('&');
  const queryString = {};
  // eslint-disable-next-line
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    const key = decodeURIComponent(pair[0]);
    const value = decodeURIComponent(pair[1]);
    // If first entry with this name
    if (typeof queryString[key] === 'undefined') {
      queryString[key] = decodeURIComponent(value);
      // If second entry with this nam
    } else if (typeof queryString[key] === 'string') {
      const arr = [queryString[key], decodeURIComponent(value)];
      queryString[key] = arr;
      // If third or later entry with this name
    } else {
      queryString[key].push(decodeURIComponent(value));
    }
  }
  return queryString;
}

/**
 * Get data from application config
 * @param {*} field
 * @returns
 */
const getAppConfig = (field) => {
  let config = null;
  try {
    config = api.getConfigByKey(field);
    config = config || null;
    return config;
  } catch {
    // token = {};
  }
  return config;
};

export function htmlDecode(content) {
  const txt = document.createElement('textarea');
  txt.innerHTML = content;
  return txt.value;
}

export function extractContent(html) {
  return new DOMParser().parseFromString(html, 'text/html');
}

export function getImageFromFiles({ files, index = 0, sub }) {
  if (sub !== undefined) return files.find((_) => _.sub === sub)?.path;
  return files?.[index]?.path;
}

export function getLogoFromFiles(files) {
  return files
    ?.filter((_) => _?.file_sub_type === 'logo')
    .sort((prev, next) => prev?.display_priority - next?.display_priority)?.[0]?.path;
}

export {
  getDate,
  toMoney,
  toNumber,
  getOptionsForSelect,
  buildKey,
  arrayMove,
  getIdentifierTypes,
  getLocalStorageValue,
  createState,
  removeLocalStorageValue,
  getRedirectUri,
  createDataFromFields,
  parseQueryString,
  getAppConfig,
};
